module.exports = "<div id=\"container\">\r\n    <router-outlet></router-outlet>\r\n</div>"